<div [formGroup]="winterStorageFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <ng-container *ngIf="headline && !slimmedView">
        <div fxFlex=100>
            <h2>{{headline}}</h2>
        </div>
    </ng-container>

    <ng-container *ngIf="topList?.length || bottomList?.length">
        <div fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field fxFlex [appearance]="appearance" floatLabel="always">
                    <mat-label>Lagerplatz</mat-label>
                    <input type="text" matInput data-test="FI-Nach Lagerplatz suchen..."
                           formControlName="winterStorage"
                           [matAutocomplete]="winterStorageSelector">
                    <button matSuffix
                            mat-icon-button
                            type="button"
                            color="warn"
                            matTooltip="Ausgewählten Lagerplatz entfernen"
                            [disabled]="!winterStorage?.id"
                            (click)="onClickRemoveWinterStorage()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                    <mat-error [hidden]="slimmedView">{{winterStorageFormGroup.get('winterStorage').errors | firstErrorMessage}}</mat-error>
                </mat-form-field>

                <mat-autocomplete #winterStorageSelector="matAutocomplete" [displayWith]="displayWinterStorageWith">
                    <ng-container *ngIf="filteredTopList$ | async as topList">
                        <ng-container *ngIf="topList.length > 0">
                            <mat-optgroup [label]="topListLabel">
                                <ng-container *ngFor="let winterStorage of topList">
                                    <mat-option [value]="winterStorage">
                                        {{winterStorage.handle}}
                                    </mat-option>
                                </ng-container>
                            </mat-optgroup>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="filteredBottomList$ | async as bottomList">
                        <mat-optgroup [label]="(topList.length > 0) ? 'Weitere Lagerplätze' : 'Alle Lagerplätze'">
                            <ng-container *ngFor="let winterStorage of bottomList">
                                <mat-option [value]="winterStorage">
                                    {{winterStorage.handle}}
                                </mat-option>
                                <ng-container *ngIf="!bottomList?.length">
                                    Keinen Lagerplatz gefunden
                                </ng-container>
                            </ng-container>
                        </mat-optgroup>
                    </ng-container>
                </mat-autocomplete>
            </div>
        </div>
    </ng-container>

</div>
